import React, {PureComponent, ReactNode, StrictMode} from 'react'

export class BrandListItemSkeleton extends PureComponent {
    render(): ReactNode {
        return (
            <StrictMode>
                <div className="w-full flex gap-3 py-3 border-b border-neutral-100 cursor-pointer">
                    <div className="w-16 bg-black-300 h-6 mb-2 rounded-md"/>
                    <div className="w-64 bg-black-300 h-6 mb-2 rounded-md"/>
                </div>
            </StrictMode>
        )
    }
}
